/* ============================================================
   api.js — CropGuard AI
   Saare backend (PHP + MySQL) calls yahan se hote hain.
   REACT_APP_API_URL .env mein set karo (e.g. https://cropguards.com/api)
   ============================================================ */

const API_URL = process.env.REACT_APP_API_URL || 'https://cropguards.com/api';
const TOKEN_KEY = 'cropguard_admin_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
export function isLoggedIn() {
  return !!getToken();
}
export function logout() {
  setToken(null);
}

async function request(path, { method = 'GET', body, auth = false, isForm = false } = {}) {
  const headers = {};
  if (!isForm) headers['Content-Type'] = 'application/json';
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(`${API_URL}/${path}`, {
    method,
    headers,
    body: isForm ? body : (body !== undefined ? JSON.stringify(body) : undefined),
  });
  let data = null;
  try { data = await res.json(); } catch (e) { /* empty response */ }
  if (!res.ok) {
    throw new Error((data && data.error) || `Request failed (${res.status})`);
  }
  return data;
}

/* ── Auth ── */
export async function login(password) {
  const data = await request('auth.php', { method: 'POST', body: { password } });
  setToken(data.token);
  return true;
}

/* ── Posts (public) ── */
export function fetchPosts() {
  return request('posts.php');
}
export function fetchAllPostsAdmin() {
  return request('posts.php', { auth: true });
}
export function fetchPostBySlug(slug) {
  return request(`posts.php?slug=${encodeURIComponent(slug)}`);
}
export function incrementViews(id) {
  return request(`posts.php?action=view&id=${id}`, { method: 'POST' }).catch(() => {});
}

/* ── Posts (admin) ── */
export function createPost(data) {
  return request('posts.php', { method: 'POST', body: data, auth: true });
}
export function updatePost(id, data) {
  return request(`posts.php?id=${id}`, { method: 'PUT', body: data, auth: true });
}
export function deletePost(id) {
  return request(`posts.php?id=${id}`, { method: 'DELETE', auth: true });
}
export function togglePin(id) {
  return request(`posts.php?id=${id}&action=toggle-pin`, { method: 'PATCH', auth: true });
}
export function toggleStatus(id) {
  return request(`posts.php?id=${id}&action=toggle-status`, { method: 'PATCH', auth: true });
}
export function duplicatePost(id) {
  return request(`posts.php?id=${id}&action=duplicate`, { method: 'PATCH', auth: true });
}

/* ── Settings ── */
export function fetchSettings() {
  return request('settings.php');
}
export function saveSettingsApi(data) {
  return request('settings.php', { method: 'PUT', body: data, auth: true });
}

/* ── Media ── */
export function fetchMedia() {
  return request('media.php', { auth: true });
}
export function uploadMedia(file) {
  const fd = new FormData();
  fd.append('file', file);
  return request('media.php', { method: 'POST', body: fd, auth: true, isForm: true });
}
export function deleteMedia(id) {
  return request(`media.php?id=${id}`, { method: 'DELETE', auth: true });
}
